module.exports = __webpack_public_path__ + "site/img/index3.1ae3cf29.png";